import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import {  useSelector } from "react-redux";
import GlobalLoader from "../../admin/shared/globalLoader";


const UserAuthLayout = () => {
  
    const loaderState = useSelector((state) => state.globalLoader);
    const navigate = useNavigate();
    window.navigate_ = navigate;

    return (
        <>
            {loaderState ? (
                <GlobalLoader />
            ) : (
                <div className="page">
                    <Outlet />
                </div>
            )}
        </>
    );
};
export default UserAuthLayout;
